module.exports = __webpack_public_path__ + "static/experience_scene3-5ed580cecd4adf42b674308385c04bf7.svg";